export enum TipoReporte {
  USUARIO = 'usuario',
  CANAL = 'canal',
}
